import React, { useEffect } from 'react';
import { Container, Col, Row, Image } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { updateQuantity, removeFromCart, updateTotalAmount } from '../../../reducers/cart';
import { Link } from 'react-router-dom';

const CartItems = () => {
    const dispatch = useDispatch();
    const cartState = useSelector(state => state.cart || {});
    const cart = Array.isArray(cartState.items) ? cartState.items : [];
    const totalAmount = Number(cartState.totalAmount || 0);

    const handleIncrement = item => {
        dispatch(updateQuantity({
            product_id: item.product_id,
            attribute_value_id: item.attribute_value_id,
            quantity: item.quantity + 1
        }));
    };

    const handleDecrement = item => {
        if (item.quantity > 1) {
            dispatch(updateQuantity({
                product_id: item.product_id,
                attribute_value_id: item.attribute_value_id,
                quantity: item.quantity - 1
            }));
        }
    };

    const handleRemove = item => {
        dispatch(removeFromCart({
            product_id: item.product_id,
            attribute_value_id: item.attribute_value_id
        }));
    };

    useEffect(() => {
        const total = cart.reduce(
            (sum, item) => sum + Number(item.subTotal || 0),
            0
        );

        if (Number(totalAmount.toFixed(2)) !== Number(total.toFixed(2))) {
            dispatch(updateTotalAmount(total.toFixed(2)));
        }
    }, [cart, totalAmount, dispatch]);

    if (!cart.length) {
        return (
            <Container>
                <Row className='pt-2'>
                    <Col>
                        <font>Home › Cart</font>

                        <div className='pt-4'>
                            <h3 style={{ fontWeight: '500' }}>Cart</h3>
                        </div>

                        <div className='text-center my-5'>
                            <Image
                                src={require('../../assets/images/empty-cart.jpg')}
                                alt='image'
                            />

                            <h3>Oops! Your Cart is empty!</h3>

                            <p>
                                Looks like you haven't added
                                <br />
                                anything to your cart yet
                            </p>

                            <Link to='/' className='btn btn-primary'>
                                Shop Now
                            </Link>
                        </div>
                    </Col>
                </Row>
            </Container>
        );
    }

    return (
        <Container className='py-5'>
            <Row className='pt-2 mb-5'>
                <Col sm={8} className='r-border pr-4'>
                    <font>Home › Cart</font>

                    <div className='pt-4'>
                        <h3 style={{ fontWeight: '500' }}>Cart</h3>
                    </div>

                    <Row className='pt-3 d-none d-lg-flex'>
                        <Col lg={5}><b>Product Name</b></Col>
                        <Col lg={2}><b>Unit Price</b></Col>
                        <Col lg={2}><b>Quantity</b></Col>
                        <Col lg={2}><b>SubTotal</b></Col>
                        <Col lg={1}></Col>
                    </Row>

                    {cart.map((item, index) => (
                        <Row key={index} className='py-4 border-b'>
                            <Col sm={5} xs={12}>
                                <Row>
                                    <Col sm={3} xs={3}>
                                        <img
                                            src={item.product_thumbnail}
                                            alt=''
                                            className='w-100'
                                        />
                                    </Col>

                                    <Col sm={9} xs={9} className='pt-3'>
                                        <p>{item.product_name}</p>
                                    </Col>
                                </Row>
                            </Col>

                            <Col sm={2} xs={3} className='pt-4'>
                                <span className='main-color'>
                                    <i className='fa fa-inr'></i>{' '}
                                    {item.product_MSP}
                                </span>
                            </Col>

                            <Col sm={2} xs={3} className='pt-4'>
                                <button
                                    className='btn p-0 font-14'
                                    onClick={() => handleDecrement(item)}
                                >
                                    -
                                </button>

                                <span className='px-3'>{item.quantity}</span>

                                <button
                                    className='btn p-0'
                                    onClick={() => handleIncrement(item)}
                                >
                                    +
                                </button>
                            </Col>

                            <Col sm={2} xs={3} className='pt-4'>
                                <font>
                                    <i className='fa fa-inr'></i>{' '}
                                    {Number(item.subTotal || 0).toFixed(2)}
                                </font>
                            </Col>

                            <Col sm={1} xs={1} className='pt-4'>
                                <button
                                    className='btn'
                                    onClick={() => handleRemove(item)}
                                >
                                    <i className='fa fa-times' aria-hidden='true'></i>
                                </button>
                            </Col>
                        </Row>
                    ))}
                </Col>

                <Col sm={4} className='px-4'>
                    <div className='mt-2'>
                        <h6 className='main-color f-w-8'>
                            <b>Order Summary</b>
                        </h6>

                        <table className='table'>
                            <tbody>
                                <tr>
                                    <td>Subtotal</td>
                                    <td className='text-end'>
                                        <i className='fa fa-inr'></i>{' '}
                                        {totalAmount.toFixed(2)}
                                    </td>
                                </tr>

                                <tr>
                                    <td>Discount (0%)</td>
                                    <td className='text-end'>
                                        <i className='fa fa-inr'></i> 0
                                    </td>
                                </tr>

                                <tr>
                                    <td>GST (0%)</td>
                                    <td className='text-end'>
                                        <i className='fa fa-inr'></i> 0.00
                                    </td>
                                </tr>

                                <tr>
                                    <td>Delivery Charge</td>
                                    <td className='text-end'>
                                        <i className='fa fa-inr'></i> 0.00
                                    </td>
                                </tr>

                                <tr>
                                    <td>Order total</td>
                                    <td
                                        className='text-end main-color'
                                        style={{ color: '#a20401' }}
                                    >
                                        <i className='fa fa-inr'></i>{' '}
                                        {totalAmount.toFixed(2)}
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <p className='text-danger'>
                            7-10 days delivery time. Depending on distance of
                            the destination.
                        </p>

                        <Link
                            className='btn w-100 mt-3 main-bg text-white'
                            to='/checkout'
                        >
                            Proceed to checkout
                        </Link>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default CartItems;